import { SectionType } from '@core/enums';
import { environment } from '@env/environment';
import { appSetting } from '@core/constants';

export function GenerateImageUrlWithToken(id: any, type: SectionType) {
  const expirationTime = Date.now() + 15 * 60 * 1000; // Current time + 15 minutes
  return environment.apiUrl + '/proxy/image/' + btoa(JSON.stringify({ imageId: id, expirationTime: expirationTime, type: type }));
}

export function GenerateMessageAttachmentUrl(image: string) {
  return environment.serverUrl + '/proxyMsg/' + image;
}

export function isImageTypeAllowedByFile(file: File) {
  return isImageTypeAllowedByName(file.name);
}

export function isImageTypeAllowedByName(imageName: string) {
  const allowedImageTypes = appSetting.imageType;
  const extension = imageName.split('.').pop();
  return allowedImageTypes.includes(extension);
}
